import React, { useState } from "react";
import { FiPlus } from "react-icons/fi";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FollowUs from "../Footer/FollowUs";
import LetsGet from "../Footer/LetsGet";
import { motion } from "framer-motion";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};


const text = "Everything You Need To Know";

  return (
    <div className="overflow-x-hidden">
      <Header />
      <div className="w-full py-28 bg-white">
      
      <div className="max-w-7xl mx-auto px-6">

        <div className="text-center mb-16">
          <p className="montserrat text-sm uppercase tracking-widest text-orange-500 font-medium">
            FAQ
          </p>
          {/* <h2 className="heading text-4xl mt-2 text-[#252525] uppercase">
            Everything You Need To Know
          </h2> */}
          <motion.h2
            className="heading text-4xl mt-2 text-[#252525] uppercase"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {text.split("").map((char, index) => (
              <motion.span
                key={index}
                variants={{
                  hidden: { opacity: 0 },
                  visible: { opacity: 1 },
                }}
                transition={{
                  delay: index * 0.07,
                  duration: 0.04,
                }}
              >
                {char}
              </motion.span>
            ))}
          </motion.h2>

          <p className="montserrat text-[#252525] mt-3">
            Working with a creative agency should feel exciting, not confusing.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          <motion.div
            className="space-y-5"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {/* FAQ 1 */}
            <motion.div
              variants={itemVariants}
              className="bg-white rounded-lg px-6 py-5 cursor-pointer shadow-xl"
              onClick={() => setOpenIndex(openIndex === 0 ? null : 0)}
            >
              <div className="flex items-center">
                <FiPlus
                  className={`text-xl transition-transform duration-300 mr-4 ${
                    openIndex === 0
                      ? "rotate-45 text-orange-500"
                      : "text-[#1B1139]"
                  }`}
                />
                <h4 className="montserrat text-black font-semibold">
                  What is Open Studios?
                </h4>
              </div>

              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openIndex === 0 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-gray-600 mt-4 leading-relaxed text-left ml-9">
                  Open Studios is a creative agency focused on branding, design,
                  and digital experiences that help businesses grow and stand out.
                </p>
              </div>
            </motion.div>

            {/* FAQ 2 */}
            <motion.div
              variants={itemVariants}
              className="bg-white rounded-lg px-6 py-5 cursor-pointer shadow-xl"
              onClick={() => setOpenIndex(openIndex === 1 ? null : 1)}
            >
              <div className="flex items-center">
                <FiPlus
                  className={`text-xl transition-transform duration-300 mr-4 ${
                    openIndex === 1
                      ? "rotate-45 text-orange-500"
                      : "text-[#1B1139]"
                  }`}
                />
                <h4 className="montserrat text-black font-semibold">
                  What services does Open Studios offer?
                </h4>
              </div>

              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openIndex === 1 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-gray-600 mt-4 leading-relaxed text-left ml-9">
                  We offer branding, UI/UX design, web development, digital
                  marketing, and creative consulting services.
                </p>
              </div>
            </motion.div>

            {/* FAQ 3 */}
            <motion.div
              variants={itemVariants}
              className="bg-white rounded-lg px-6 py-5 cursor-pointer shadow-xl"
              onClick={() => setOpenIndex(openIndex === 2 ? null : 2)}
            >
              <div className="flex items-center">
                <FiPlus
                  className={`text-xl transition-transform duration-300 mr-4 ${
                    openIndex === 2
                      ? "rotate-45 text-orange-500"
                      : "text-[#1B1139]"
                  }`}
                />
                <h4 className="montserrat text-black font-semibold">
                  Which industries do you work with?
                </h4>
              </div>

              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openIndex === 2 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-gray-600 mt-4 leading-relaxed text-left ml-9">
                  We work with startups, SaaS, e-commerce, creators, and growing
                  businesses across multiple industries.
                </p>
              </div>
            </motion.div>

            {/* FAQ 4 */}
            <motion.div
              variants={itemVariants}
              className="bg-white rounded-lg px-6 py-5 cursor-pointer shadow-xl"
              onClick={() => setOpenIndex(openIndex === 3 ? null : 3)}
            >
              <div className="flex items-center">
                <FiPlus
                  className={`text-xl transition-transform duration-300 mr-4 ${
                    openIndex === 3
                      ? "rotate-45 text-orange-500"
                      : "text-[#1B1139]"
                  }`}
                />
                <h4 className="montserrat text-black font-semibold">
                  Do you provide customised marketing strategies?
                </h4>
              </div>

              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openIndex === 3 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-gray-600 mt-4 leading-relaxed text-left ml-9">
                  Yes, every strategy is tailor-made based on your goals,
                  audience, and market position.
                </p>
              </div>
            </motion.div>

            {/* FAQ 5 */}
            <motion.div
              variants={itemVariants}
              className="bg-white rounded-lg px-6 py-5 cursor-pointer shadow-xl"
              onClick={() => setOpenIndex(openIndex === 4 ? null : 4)}
            >
              <div className="flex items-center">
                <FiPlus
                  className={`text-xl transition-transform duration-300 mr-4 ${
                    openIndex === 4
                      ? "rotate-45 text-orange-500"
                      : "text-[#1B1139]"
                  }`}
                />
                <h4 className="montserrat text-black font-semibold">
                  Do you offer monthly marketing packages?
                </h4>
              </div>

              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openIndex === 4 ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-gray-600 mt-4 leading-relaxed text-left ml-9">
                  Yes, we provide flexible monthly packages depending on your
                  needs and scale.
                </p>
              </div>
            </motion.div>
          </motion.div>

            <div className="flex flex-col items-center text-center">
            {/* <motion.div
                        variants={fadeRight}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="flex flex-col items-center text-center"
                      > */}
              {/* <div className=" flex items-center justify-center mb-8">
                  <img
                    src="/assets/FAQ.png" 
                    alt="question"
                    className="w-60 h-60 object-contain"
                  />
                </div> */}
                <div className="flex items-center justify-center mb-8">
                <motion.div
                  className="relative w-60 h-60"
                  animate={{
                    scale: [1, 1.08, 1],
                  }}
                  transition={{
                    duration: 3,
                    ease: "easeInOut",
                    repeat: 4, 
                  }}
                >
                  <img
                    src="/assets/FAQ.png"
                    alt="Background Shape"
                    className="w-full h-full object-contain"
                  />
                  <img
                    src="https://static.vecteezy.com/system/resources/thumbnails/054/019/906/small/question-mark-with-shadow-effect-png.png"
                    alt="Question"
                    className="absolute inset-0 m-auto w-1/2 h-1/2 object-contain"
                  />

                </motion.div>
              </div>
            {/* <div className="flex items-center justify-center mb-8">
              <div className="relative w-60 h-60">
                
                <img
                  src="/assets/FAQ.png" 
                  alt="Background Shape"
                  className="w-full h-full object-contain"
                />

                <img
                  src="https://static.vecteezy.com/system/resources/thumbnails/054/019/906/small/question-mark-with-shadow-effect-png.png" 
                  alt="Question"
                  className="absolute inset-0 m-auto w-1/2 h-1/2 object-contain"
                />
              </div>
            </div> */}

            <h3 className="montserrat text-2xl font-semibold">Any Question?</h3>
            <p className="text-black mt-2 montserrat">
              You can ask anything you want to know
            </p>

            {/* <div className="w-full mt-6">
              <p className="montserrat font-semibold text-left mb-2">
                Let me know
              </p>
              <input
                type="text"
                className="w-full border border-gray-300 rounded-full px-5 py-3 focus:outline-none focus:ring-1 focus:ring-orange-500"
              />
            </div> */}
            <div className="w-full mt-6">
            <p className="montserrat font-semibold text-left mb-2">
              Let me know
            </p>
            <div className="relative w-full">
              <input
                type="text"
                placeholder="Type something..."
                className="w-full border border-gray-300 rounded-full px-5 py-3 pr-28 focus:outline-none focus:ring-1 focus:ring-orange-500"
              />
              <a href="/">
              <button
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-orange-500 text-white font-semibold px-5 py-2 rounded-full hover:bg-orange-600 transition-colors"
              >
                Submit
              </button></a>
            </div>
          </div>
          {/* </motion.div>   */}
          </div>

        </div>
      </div>
    </div>

      <LetsGet />         
      <FollowUs />      
      <Footer />          
    </div>
  );
};

export default FAQ;
